import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useCreateConsent } from '@axo/shared/data-access/hooks';
import { MarketCountryCode } from '@axo/shared/types';
import {
  handleConsentCreateError,
  handleConsentCreateSuccess,
} from '../utils/consentHandlers';

export interface AddMarketingConsentParams {
  configId: number | undefined;
  agentID: string;
  applicationId: string;
  country: MarketCountryCode;
  customerID: string;
  originBrandID: string;
}

export function useAddMarketingConsent() {
  const createConsent = useCreateConsent();
  const queryClient = useQueryClient();

  const addMarketingConsent = useCallback(
    ({
      configId,
      agentID,
      applicationId,
      country,
      customerID,
      originBrandID,
    }: AddMarketingConsentParams) => {
      const consentOriginAction = `phone-call-agent-${agentID}-app-${applicationId}`;

      createConsent.mutate(
        {
          ConfigType: 'MARKETING',
          ConfigID: configId,
          Country: country,
          Lang: country,
          CustomerID: customerID,
          OriginAction: consentOriginAction,
          OriginBrandID: originBrandID,
          ForceGiven: true,
        },
        {
          onSuccess: () =>
            handleConsentCreateSuccess(country, customerID, queryClient),
          onError: handleConsentCreateError,
        }
      );
    },
    [createConsent, queryClient]
  );

  return {
    addMarketingConsent,
    isLoading: createConsent.isLoading,
    isError: createConsent.isError,
    error: createConsent.error,
  };
}
